import styled from 'styled-components';
import { Checkbox } from 'antd';
import { COLORS } from 'theme';

export const FilterSection = styled.div`
  margin-bottom: 24px;
`;

export const FilterTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
  color: ${COLORS.TEXT_HIGH_EMPHASIS};
`;

export const FilterGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
